import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocalization } from 'components/methods'

type ParametersProps = {
  description?: string,
  keywords?: string,
}
type PageMetatagsProps = {
  title: string,
  parameters?: ParametersProps,
}
const PageMetatags = ({ title, parameters }: PageMetatagsProps) => {
  const { t } = useLocalization()

  return (
    <Helmet>
      <title>{title} | {t('GEL.whitelabel.app.name')}</title>
      {parameters &&
        <>
          <meta name="description" content={parameters.description} />
          <meta name="keywords" content={parameters.keywords} />
        </>
      }
    </Helmet>
  )
}

export default PageMetatags
